import { ShieldIcon, BoltIcon, SparkIcon } from '../shared/icons'

export function TrustBar() {
  return (
    <div className="mx-auto max-w-7xl px-4 md:px-6 -mt-8 mb-12">
      <div className="rounded-2xl border border-border-light bg-surface-light/60 backdrop-blur p-4 flex items-center justify-between flex-wrap gap-4">
        <div className="flex items-center gap-2 text-muted text-sm">
          <ShieldIcon />
          <span>Canada‑first privacy</span>
        </div>
        <div className="flex items-center gap-2 text-muted text-sm">
          <BoltIcon />
          <span>Read‑only Stripe · GA4 · PostHog</span>
        </div>
        <div className="flex items-center gap-2 text-muted text-sm">
          <SparkIcon />
          <span>Shareable proof cards</span>
        </div>
      </div>
    </div>
  )
}
